
import { mapActions } from 'vuex'

export default {
  name: 'ProductInfos',
  props: {
    product: {
      type: Object,
      required: true
    },
    selectedVariants: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    displayDescription: false,
    displayVariantWarning: false
  }),
  computed: {
    quantity() {
      return this.$store.getters['cart/itemCount'](this.product.id)
    },
    hasVariant() {
      return Object.keys(this.selectedVariants).length > 0
    },
    isVariantsValid() {
      if (!this.hasVariant) return true
      return Object.values(this.selectedVariants).every(Boolean)
    }
  },
  watch: {
    isVariantsValid(isValid) {
      if (isValid) this.displayVariantWarning = false
    }
  },
  methods: {
    ...mapActions('cart', ['addToCart', 'removeFromCart']),
    submitProduct() {
      if (this.isVariantsValid) {
        this.addToCart({
          ...this.product,
          ...(this.hasVariant && { selectedVariants: this.selectedVariants })
        })
      } else {
        this.displayVariantWarning = true
      }
    }
  }
}
